export default __webpack_public_path__ + "static/media/coins.72e6a1d2.svg";